const TMSConstant = require('@pando/tms-constants');

module.exports = TMSConstant;
